import { oc } from "@orpc/contract";
import { z } from "zod";

const SearchOrderdadTransactionSchema = z
  .object({
    id: z.string(),
    rowIndex: z.number().nullable(),
    sourceFile: z.string(),
    sourceDivision: z.string(),
  })
  .catchall(z.union([z.string(), z.number()]).nullable());

const PaginationSchema = z.object({
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
  hasMore: z.boolean(),
});

const FileMetadataSchema = z.object({
  fileName: z.string(),
  lastModified: z.string(),
  totalRows: z.number().int().nonnegative(),
});

export const SearchOrderdadInputSchema = z.object({
  orderCompany: z.string().optional(),
  orderDivision: z.string().optional(),
  orderNumber: z.string().optional(),
  supplier: z.string().optional(),
  claimNumber: z.string().optional(),
  customUse: z.string().optional(),
  filters: z.record(z.string(), z.string()).optional(),
  limit: z.number().int().positive().max(500).optional().default(100),
  offset: z.number().int().nonnegative().optional().default(0),
  sortBy: z.string().optional(),
  sortDirection: z.enum(["asc", "desc"]).optional().default("desc"),
});

export const SearchOrderdadResponseSchema = z.object({
  transactions: z.array(SearchOrderdadTransactionSchema),
  pagination: PaginationSchema,
  fileMetadata: z.array(FileMetadataSchema),
});

export const orderdadSearchContracts = {
  search: oc
    .input(SearchOrderdadInputSchema)
    .output(SearchOrderdadResponseSchema)
    .route({
      summary: "Search ERP order claim detail records",
      description:
        "Searches imported ERP order detail rows by order company, division, order number, supplier, claim number, or custom field, with paging and sorting.",
      method: "GET",
    }),
} as const;

export type SearchOrderdadInput = z.infer<typeof SearchOrderdadInputSchema>;
export type SearchOrderdadResponse = z.infer<
  typeof SearchOrderdadResponseSchema
>;
